import { BET_TYPES } from '../enums/betTypesEnum';

export const statisticWinnerListHandler = (winnersList) => {
  let rowCount = 7;
  const result = [];
  let x = 0;
  let y = 0;
  let stepToLeft = 0;
  let lastType = null;
  let isFirstTypeTie = false;
  const finallyResult = [];

  for (let i = 0; i < rowCount; i += 1) {
    result.push([]);
  }

  const winnerTableHandler = (roundData) => {
    const { winType, isPairWin } = roundData;
    if (isFirstTypeTie && winType !== BET_TYPES.TIE) {
      lastType = winType;
      isFirstTypeTie = false;
    }
    if (!x && !y) {
      result[y][x] = { winType, isPairWin };
      if (winType === BET_TYPES.TIE) {
        isFirstTypeTie = true;
      }
      lastType = winType;
      y += 1;
    } else if ((lastType === winType || winType === BET_TYPES.TIE) && y === rowCount) {
      x += 1;
      result[y - 1][x] = { winType, isPairWin };
      stepToLeft += 1;
    } else if ((lastType === winType || winType === BET_TYPES.TIE) && y <= rowCount) {
      result[y][x] = { winType, isPairWin };
      y += 1;
    } else {
      y = 0;
      lastType = winType;
      x -= stepToLeft - 1;
      result[y][x] = { winType, isPairWin };
      y += 1;
      if (stepToLeft) {
        rowCount -= 1;
        stepToLeft = 0;
      }
    }
  };

  if (winnersList && winnersList.length) {
    winnersList?.forEach(({ roundData }) => {
      winnerTableHandler(roundData);
    });
  }

  if (result.length) {
    let condition = 0;
    result.forEach((item) => {
      if (item.length > condition) {
        condition = item.length;
      }
    });
    for (let j = 0; j < condition; j += 1) {
      for (let i = 0; i < result.length; i += 1) {
        finallyResult.push(result[i][j] !== undefined ? result[i][j] : null);
      }
    }
  }
  return finallyResult;
};
